import React from 'react'
import { FormattedMessage } from 'react-intl'

// components
import RichText from '../../../../components/RichText/RichText'

// styles
import * as SC from './NpStatisticsSectionStyles'
import { HomePageContainer } from '../../HomePageStyles'

// types
import { CmsHomepageData } from '../../../../types/types'

type Props = {
	cmsData: CmsHomepageData['npStatisticsData']
}

const getStatisticsItem = (data: CmsHomepageData['npStatisticsData']['professionalsStatistics']) => {
	if (data.isRichText) {
		return <RichText data={data.data} />
	}

	return (
		<FormattedMessage
			id={data.data.message}
			values={{
				span: (chunks) => <SC.Highlight>{chunks}</SC.Highlight>
			}}
		/>
	)
}

// component
const NpStatisticsSection = (props: Props) => {
	const { cmsData } = props

	const { salonsStatistics, professionalsStatistics, reservationsStatistics } = cmsData

	return (
		<section>
			<HomePageContainer>
				<SC.Layout>
					<SC.StatisticsItem>
						<SC.Text>{getStatisticsItem(salonsStatistics)}</SC.Text>
					</SC.StatisticsItem>
					<SC.Divider />
					<SC.StatisticsItem>
						<SC.Text>{getStatisticsItem(professionalsStatistics)}</SC.Text>
					</SC.StatisticsItem>
					<SC.Divider />
					<SC.StatisticsItem>
						<SC.Text>{getStatisticsItem(reservationsStatistics)}</SC.Text>
					</SC.StatisticsItem>
				</SC.Layout>
			</HomePageContainer>
		</section>
	)
}

export default NpStatisticsSection
